import { MAX_HIERARCHY_HOPS } from "./constants.js";

/**
 * Walk up from descendant through manager_id chain to see if ancestorId
 * is in the management chain. Returns false if ancestorId === descendantId.
 */
export function isAncestorOf(
  users: Array<{ id: string; manager_id?: string | null }>,
  ancestorId: string,
  descendantId: string,
): boolean {
  if (ancestorId === descendantId) return false;

  const managerMap = new Map<string, string | null>();
  for (const user of users) {
    managerMap.set(user.id, user.manager_id ?? null);
  }

  let current = descendantId;
  let hops = 0;

  while (hops < MAX_HIERARCHY_HOPS) {
    const managerId = managerMap.get(current);
    if (managerId === undefined || managerId === null) return false;
    if (managerId === ancestorId) return true;
    current = managerId;
    hops++;
  }

  return false;
}
